import React, { useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components/";
import { _Dropzone, _ButtonAPI } from "../../components";
import { GetUserImg } from "../../helpers/Common";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    avatar: {
        width: 110,
        height: 110,
        margin: "0 auto",
        marginBottom: spacing(1)
    }
}));

interface IUserProfileProps {
    Data: Dati.CDatiUtente;
    OnImageChange: (fileName: string) => void;
    SetDialog: (v: Glob.CDialog) => void;
}

export const _UserProfile: React.FC<IUserProfileProps> = ({ Data, OnImageChange, SetDialog }) => {
    const classes = useStyles();
    const [DroppedFile, setDroppedFile] = useState<File | undefined>(undefined);

    const OnFileDrop = (files: File[]) => {
        setDroppedFile(files[0] ?? undefined);
    };

    const GetUploadReqData = (): FormData => {
        const reqData = new FormData();
        const userData = new Dati.CRisAPIDatoTipiInfoUtente();

        userData.Dato = Data;
        reqData.append("ingr", JSON.stringify(userData));

        if (DroppedFile) {
            reqData.append("file", DroppedFile);
        }

        return reqData;
    };

    const OnClickUploadImage = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            SetDialog({ Open: true, Title: "ERRORE", Content: Trad.Trad(data.ErrTesto), Type: "error" });
        } else {
            OnImageChange(data.MessaggioDati);
        }
    };

    const OnError = (error: Error) => {
        SetDialog({ Open: true, Title: "ERRORE", Content: error.message, Type: "error" });
    };

    return (
        <Card>
            <CardHeader title={Trad.Trad("il tuo profilo")} titleTypographyProps={{ variant: "h6" }} />
            <CardContent>
                <Box textAlign="center">
                    <Avatar className={classes.avatar} src={GetUserImg(Data.Immagine)} />
                    <Typography variant="subtitle1" gutterBottom>
                        {`${Data.Nome ?? ""} ${Data.Cognome ?? ""}`}
                    </Typography>
                    <Typography variant="caption" display="block" gutterBottom>
                        {Data.Email}
                    </Typography>
                </Box>
                <_Dropzone OnFileDrop={OnFileDrop} />
            </CardContent>
            <CardActions disableSpacing>
                <Grid container item xs={12} justify="flex-end">
                    <_ButtonAPI InviaFile Testo={Trad.Trad("Upload")} URL="/api/file/UploadImmagineProfilo" OnInvio={GetUploadReqData} OnClick={OnClickUploadImage} OnErrore={OnError} />
                </Grid>
            </CardActions>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/User/UserProfile.tsx